import { SetSchedulePopup } from './SetSchedule';

export default SetSchedulePopup;
